import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadPagePanel } from '../../../../components';
import { useGetWorkOrder } from '../api/get-work-order';
import { RefetchScope, WorkOrderContext } from '../context/WorkOrderContext';
import { WorkOrderContextType } from '../types/WorkOrderContextType';


export default function WorkOrderPage(props: React.PropsWithChildren<unknown>) {

	const params = useParams();
	const workOrderID = parseInt(params.workOrderID!);

	const [orderState, setOrderState] = useState<WorkOrderContextType>({} as WorkOrderContextType);
	const { data: woData, isLoading, refetch, isRefetching } = useGetWorkOrder(workOrderID);
	const [refetchScope, setRefetchScope] = useState<RefetchScope | undefined>();

	// Clear context on order ID change 
	if (orderState.details && orderState.details.workOrderID !== workOrderID) {
		setOrderState({} as WorkOrderContextType);
	}

	useEffect(() => {
		if (woData) {
			switch (refetchScope) {
				case RefetchScope.Files:
					setOrderState({
						details: { ...orderState.details, files: woData.files }, originalDetails: woData,
						modified: orderState.modified
					});
					break;

				case RefetchScope.Notes:
					setOrderState({
						details: { ...orderState.details, notes: woData.notes }, originalDetails: woData,
						modified: orderState.modified
					});
					break;

				default:
					setOrderState({ details: woData, originalDetails: woData, modified: false });
					break;
			}
		}
	}, [woData]);

	return (
		<React.Fragment>
			{
				orderState.details &&
				<WorkOrderContext.Provider value={{
					order: orderState,
					modifyOrder: (details) => setOrderState(
						{ ...orderState, details: details, modified: true }),
					refetchOrder: (scope?: RefetchScope) => {
						setRefetchScope(scope);
						return refetch();
					}
				}}>

					<div className={'content-block order-page'}>
						{props.children}
					</div>
				</WorkOrderContext.Provider>
			}

			<LoadPagePanel visible={isLoading || isRefetching} />
		</React.Fragment>)
}
